import React, { useState, useEffect } from 'react';
import './Testimonials.css';
import useScrollAnimation from '../hooks/useScrollAnimation';

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const sectionRef = useScrollAnimation();

  const testimonials = [
    {
      name: "Sumeeti",
      content: "I got done my tax filing using profit pioneers services and I am very much satisfied with the work done by them. Big shout out to Deepika for providing such an excellent and transparent service. I got done my tax filing previously from others but was never satisfied with their work, this firm puts extra effort to get maximum tax returns. I recommend them to anyone looking for any kind of accounting or bookkeeping or tax filing services.",
      rating: 5,
      date: "2024-03-15",
      initial: "S"
    },
    {
      name: "Nisha Notey",
      content: "I recently had this accounting and bookkeeping company file my tax return, and I'm thoroughly impressed! They are incredibly efficient, detail-oriented, and made the entire process stress-free. Their expertise ensured I received the best possible outcome, and they took the time to explain everything clearly. I highly recommend them for anyone needing top-notch tax and accounting services!",
      rating: 5,
      date: "2024-03-12",
      initial: "N"
    },
    {
      name: "Himanshi Mahlan",
      content: "I had a wonderful experience working with Deepika for my tax refund filing. She is incredibly humble, patient, and professional throughout the entire process. She took the time to explain everything clearly, answered all my questions without hesitation, and made sure every detail was handled with care. Her calm and friendly approach made the entire experience stress-free. I truly appreciate her dedication and would highly recommend her to anyone looking for reliable and honest assistance with tax filing.",
      rating: 5,
      date: "2024-03-10",
      initial: "H"
    },
    {
      name: "Randeep Singh",
      content: "Deepika Sharma is awesome! Super friendly, easy to talk to, and really knows their stuff. She make taxes and accounting stress-free, always explain things in simple terms, and helped me to get tax returns. She is quick to respond whenever I need help. Honestly, I wouldn't trust anyone else with my finances—highly recommend!",
      rating: 5,
      date: "2024-03-08",
      initial: "R"
    },
    {
      name: "Sonika Agnihotri",
      content: "I had a great experience working with Profit Pioneers for my recent tax filing. They were organized, easy to communicate with, and really helped simplify a process that can usually feel overwhelming. Overall, they were reliable, professional, and easy to work with. If you're looking for someone dependable to handle your taxes, I'd definitely recommend giving Profit Pioneers a try.",
      rating: 5,
      date: "2024-03-05",
      initial: "S"
    },
    {
      name: "Gurjeet Kaur Banipal",
      content: "Truly I had a incredible experience with this accounting and bookkeeping firm especially with Sandeep. She is incredibly humble, polite and professional throughout the whole process of tax refund filling. I truly appreciate her dedication, would highly recommend accounting and bookkeeping firm to anyone looking for positive guidance about tax refund filing.",
      rating: 5,
      date: "2024-03-03",
      initial: "G"
    },
    {
      name: "Sanam Sampla",
      content: "I recently worked with Deepika Sharma for my tax filing, and I couldn't be more satisfied with the experience. From the beginning, They are professional, organized, and incredibly knowledgeable about the latest tax laws and deductions. They took the time to answer all my questions, explain everything clearly, and ensured I was getting the best possible return.",
      rating: 5,
      date: "2024-03-01",
      initial: "S"
    },
    {
      name: "Joeffin Joseph",
      content: "I had a fantastic experience working with Deepika. She is extremely knowledgeable, detail-oriented, and made the entire tax process smooth and stress-free. She took the time to explain everything clearly, answered all my questions, and helped me maximize my deductions. I really appreciated her prompt communication and professionalism throughout. I highly recommend Deepika to anyone looking for a trustworthy and skilled tax consultant.",
      rating: 5,
      date: "2024-02-28",
      initial: "J"
    },
    {
      name: "Aman Gill",
      content: "Deepika Sharma is honestly amazing! Every single time I've called, she's picked up right away and handled everything so smoothly. No matter what the issue is, she fixes it without any stress or hassle. You can tell she genuinely cares about her clients. It's super rare to find someone that reliable and easy to talk to. I'm really glad I found Profit Pioneers—highly recommend them to anyone looking for solid accounting or bookkeeping help.",
      rating: 5,
      date: "2024-02-25",
      initial: "A"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="testimonials section fade-in-right" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What Our Clients Say About Us</h2>
          <p className="section-subtitle">We take pride in helping our clients achieve financial success and peace of mind. Below are some of the experiences they've shared.</p>
        </div>

        <div className="google-reviews-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="google-review-card">
              <div className="review-header">
                <div className="reviewer-info">
                  <div className="reviewer-avatar">
                    {testimonial.initial}
                  </div>
                  <div className="reviewer-details">
                    <div className="reviewer-name">{testimonial.name}</div>
                    <div className="review-date">{testimonial.date}</div>
                  </div>
                </div>
                <div className="google-logo">
                  <svg width="16" height="16" viewBox="0 0 24 24">
                    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                  </svg>
                </div>
              </div>
              
              <div className="review-rating">
                <div className="stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="star">★</span>
                  ))}
                </div>
                <div className="verified-check">
                  <span className="check-icon">✓</span>
                </div>
              </div>
              
              <div className="review-content">
                {testimonial.content}
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-cta-small">
          <a 
            href="https://maps.app.goo.gl/4Kdr9ZGKyhyDoujy8" 
            target="_blank" 
            rel="noopener noreferrer"
            className="top-reviews-btn-small"
          >
            View More Reviews
          </a>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;

